import { TaskStartDatePeriod } from "Models/task";

const taskMultiDay = [
  TaskStartDatePeriod.MULTI_DAY,
  TaskStartDatePeriod.FIXED_TIME,
  TaskStartDatePeriod.VARIABLE_TIME,
];

export function isTaskMultiDay(taskPeriod?: number): boolean {
  if (!taskPeriod) return false;

  return taskMultiDay.includes(taskPeriod);
}
